export default "__VITE_ASSET__DIDPlWoQ__"